/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { ON_SCHEDULE_DATA, LOADER_STATUS, STATUS_MSG } from './constants';

// The initial state of the App
export const initialState = {
  scheduleData: '',
  loaderStatus: false,
  status: false,
  msg: ''
};

/* eslint-disable default-case, no-param-reassign */
const scheduleReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case ON_SCHEDULE_DATA:
        return {
          ...state,
          scheduleData:action.scheduleData
        }
      case STATUS_MSG:
        return {
          ...state,
          status:action.status,
          msg:action.msg
        }
      default:
        return state;
    }
  };

export default scheduleReducer;
